import list from './shop/list'
import get from './shop/get'
export default {list,get}
